<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="85%" @open="addOpen" :close-on-click-modal="false">
    <el-card>
      <el-row :gutter="20">
        <el-col :span="2">
          <el-button type="primary" @click="showAddDialog">添加文章</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="content_id" label="文章ID" align="center"></el-table-column>
        <el-table-column prop="content_title" label="文章标题" align="center">
          <template slot-scope="scope">
            <a v-if="scope.row.content_id > 0" :href="scope.row.content_url" target="_blank">{{scope.row.content_title}}</a>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-arrow-up" size="mini" :disabled="scope.$index === 0" @click="move(scope.$index, -1)"></el-button>
            <el-button type="primary" icon="el-icon-arrow-down" size="mini" :disabled="scope.$index === list.length - 1" @click="move(scope.$index, 1)"></el-button>
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="param.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="param.count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
    <classical-content-add :visible="addDialogAvaible"
      :id="currentId"
      :classical_id="id"
      @add="add"
      @update="update"
      @closeDialog="closeAddDialog">
    </classical-content-add>
  </el-dialog>
</template>

<script>
import ClassicalContentAdd from './ClassicalContentAdd.vue'
export default {
  name: 'classical_content_list',
  props: [
    'visible', 'id'
  ],
  components: {
    'classical-content-add': ClassicalContentAdd
  },
  data () {
    return {
      title: '专题文章列表',
      list: [],
      total: 0,
      pageTotal: 1,
      param: {
        classical_id: 0,
        page: 1,
        count: 10
      },
      currentId: 0,
      addDialogAvaible: false
    }
  },
  methods: {
    closeDialog () {
      this.param = {
        classical_id: 0,
        page: 1,
        count: 10
      }
      this.$emit('closeDialog')
    },
    addOpen () {
      this.param.classical_id = this.id
      this.getList()
    },
    async getList () {
      const res = await this.$http.get('/admin/classical_content/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    async move (index, direction) {
      const other = this.list[index + direction]
      if (!other) return
      const row = this.list[index]
      const res = await this.$http.post('/admin/classical_content/swap_sort/' + row.id, { other_id: other.id })
      if (res.code === 0) this.getList()
      else this.$message.error(res.msg)
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    showEditDialog (id) {
      this.currentId = id
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.currentId = 0
      this.addDialogAvaible = false
    },
    async add (data) {
      const res = await this.$http.post('/admin/classical_content/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async update (id, data) {
      const res = await this.$http.post('/admin/classical_content/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/classical_content/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style>
</style>
